import React, {
  createContext,
  useContext,
  useCallback,
  useState
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setUserLocation } from 'store/auth/actions';

const LocationContext = createContext();

export const useAppLocation = () => {
  const context = useContext(LocationContext);
  if (!context) {
    throw new Error('useAppLocation must be used within LocationProvider');
  }
  return context;
};

export const LocationProvider = ({ children }) => {
  const dispatch = useDispatch();

  const location = useSelector((state) => state.location);

  const [locationError, setLocationError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const getLocation = useCallback(() => {
    if (!navigator.geolocation) {
      setLocationError('Geolocation is not supported by this browser.');
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    setLocationError(null);

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;

        dispatch(
          setUserLocation({
            latitude,
            longitude,
            timestamp: Date.now()
          })
        );

        setIsLoading(false);
      },
      (error) => {
        setIsLoading(false);
        setLocationError(error.message);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 60000
      }
    );
  }, [dispatch]);


  const value = {
    coordinates: location?.latitude ? location : null,
    hasCoordinates: !!location?.latitude,
    isLoading,
    locationError,
    refreshLocation: getLocation,
  };

  return (
    <LocationContext.Provider value={value}>
      {children}
    </LocationContext.Provider>
  );
};